import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ModalModule } from 'ngx-bootstrap/modal';

import { LoadModule } from '@shared/components/load/load.module';
import { SharedModule } from '@shared/shared.module';

import { ContactSearchComponent } from './contact-search.component';
import { FormFieldsModule } from '../form-fields/form-fields.module';
import { SearchModule } from '../search/search.module';

@NgModule({
  declarations: [ContactSearchComponent],
  imports: [
    CommonModule,
    ModalModule.forRoot(),
    RouterModule,
    SearchModule,
    LoadModule,
    SharedModule,
    FormFieldsModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [ContactSearchComponent]
})
export class ContactSearchModule {}
